import { CheckCircle2, AlertTriangle } from "lucide-react";
import { fmt } from "@/lib/catalog";
import { ZONES, HOOK_CAP } from "@/lib/statics";
import { ZONE_COLORS } from "@/lib/fields";

import { tr } from "@/lib/i18n";
const pct = (x) => `${Math.round(x * 100)}%`;
const Ut = ({ v }) => <span className={`font-tech ${v > 1 ? "text-amber-700 font-semibold" : v > 0.85 ? "text-amber-600" : "text-slate-700"}`}>{pct(v)}</span>;
const ZoneTag = ({ z }) => <span className="inline-flex items-center gap-1.5 font-tech"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: ZONE_COLORS[z] }} />{z}</span>;

export const StaticsTable = ({ p, statics, flat }) => {
  const rows = statics.fields.flatMap((f) => ZONES.filter((z) => f.zones[z]).map((z) => ({ f, z, d: f.zones[z] })));
  const cap = HOOK_CAP[p.covering] || HOOK_CAP.altro;
  const th = "py-2 pr-3 text-left text-xs font-tech uppercase tracking-wider text-slate-500";
  return (
    <div>
      <div className={`flex items-center gap-2 mb-4 text-sm font-medium ${statics.ok ? "text-emerald-700" : "text-amber-700"}`} data-testid="statics-status">
        {statics.ok ? <CheckCircle2 className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
        {statics.ok ? tr("Tutte le zone risultano verificate (stima)") : tr("Alcune zone non sono verificate anche con l'interasse minimo: aumentare gli ancoraggi o rivedere il layout")}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="statics-table">
          <thead className="border-b border-slate-200">
            {flat ? (
              <tr><th className={th}>{tr("Campo")}</th><th className={th}>{tr("Zona")}</th><th className={th}>{tr("Moduli")}</th><th className={th}>cp</th><th className={th}>{tr("Sollev. kN/mod")}</th><th className={th}>{tr("Spinta kN/mod")}</th><th className={th}>{tr("Zavorra kg/mod")}</th><th className={th}>{tr("Blocchi/mod")}</th><th className={th}>{tr("kg/m²")}</th></tr>
            ) : (
              <tr><th className={th}>{tr("Campo")}</th><th className={th}>{tr("Zona")}</th><th className={th}>{tr("Moduli")}</th><th className={th}>cp</th><th className={th}>{tr("q↓ SLU kN/m²")}</th><th className={th}>{tr("q↑ SLU kN/m²")}</th><th className={th}>{tr("Interasse")}</th><th className={th}>{tr("Binario")}</th><th className={th}>{tr("Freccia")}</th><th className={th}>{tr("Gancio")}</th></tr>
            )}
          </thead>
          <tbody>
            {rows.map(({ f, z, d }) => (
              <tr key={`${f.fid}-${z}`} className="border-b border-slate-100" data-testid={`statics-row-${f.fid}-${z}`}>
                <td className="py-2 pr-3">{f.name}{!flat && <span className="text-xs text-slate-400 ml-1">{f.pitch}°</span>}</td>
                <td className="py-2 pr-3"><ZoneTag z={z} /></td>
                <td className="py-2 pr-3 font-tech">{d.n}</td>
                <td className="py-2 pr-3 font-tech">{fmt(d.cp)}</td>
                {flat ? (
                  <>
                    <td className="py-2 pr-3 font-tech">{fmt(d.U)}</td>
                    <td className="py-2 pr-3 font-tech">{fmt(d.H)}</td>
                    <td className="py-2 pr-3 font-tech">{fmt(d.ballastKg, 1)}</td>
                    <td className="py-2 pr-3 font-tech">{d.blocks}</td>
                    <td className="py-2 pr-3 font-tech">{fmt(d.kgm2, 1)}</td>
                  </>
                ) : (
                  <>
                    <td className="py-2 pr-3 font-tech">{fmt(d.qDown)}</td>
                    <td className="py-2 pr-3 font-tech">{fmt(d.qUp)}</td>
                    <td className="py-2 pr-3 font-tech">{fmt(d.span)} m</td>
                    <td className="py-2 pr-3"><Ut v={d.railUt} /></td>
                    <td className="py-2 pr-3"><Ut v={d.deflUt} /></td>
                    <td className="py-2 pr-3"><Ut v={d.hookUt} /></td>
                  </>
                )}
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={10} className="py-6 text-center text-slate-400">{tr("Nessun modulo posato.")}</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500 mt-3">
        {flat
          ? tr("Zavorra per zona contro sollevamento e scorrimento (γQ = 1,5, γG = 0,9, attrito μ = 0,6). Verificare la portata del solaio.")
          : tr("Combinazioni SLU: 1,3·G + 1,5·S + 0,9·W e 1,3·G + 1,5·W + 0,75·S; sollevamento 1,5·W − 1,0·G. Binario generico Wel = 4,5 cm³, I = 12 cm⁴, freccia ≤ L/150. Portata ancoraggio {0} kN ↓ / {1} kN ↑.", [fmt(cap.down, 1), fmt(cap.up, 1)])}
        {" "}{tr("Larghezza zone e = min(b; 2h).")}
      </p>
    </div>
  );
};
